
import '../App.css';
import React, {useState} from 'react';


//medals
import ArmedForcesExpiditionary from '../images/Medals/Armed Forces Expiditionary.svg';
import ArmyOverseasService from '../images/Medals/Army Overseas Service.svg'
import GlobalWarOnTerrorism from '../images/Medals/Global War on Terrorism Expeditonary.svg'
import JointServiceAchievement from '../images/Medals/Joint Service Achievement.svg'
import AfghanistanCampaign from '../images/Medals/Afghanistan Campaign.svg'
import ArmySeaDuty from '../images/Medals/Army Sea Duty.svg'
import IraqCampaign from '../images/Medals/Iraq Campaign.svg'


//wedges
import Wedge2 from '../images/QmcApprovedEvents/JointTour_18.04.25.png'
import Wedge3 from '../images/QmcApprovedEvents/Deployment_21.04.25.png'
import Wedge4 from '../images/QmcApprovedEvents/Deployment_04.07.25.png'

import DeploymentCard from '../components/DeploymentCard.jsx';

function Deployments({showToast}) {
  return (
    <>
      <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
        <hr class="my-2" />
        <h3>Zanances USAR</h3>
        <h1>503rd Battalion</h1>
        <hr class="my-4" />
      </div>
    
     <DeploymentCard showToast={showToast} title="Joint tour on USAF base" description="Joint tour on the USAF base, lasting around two hours with around ten attendees on 18th April 2025." image={Wedge2} medals={[]} campaignMedals={[JointServiceAchievement]} attendees={["Noay_HD1", "Lvvtqq", "Imacoolgamer_246", "ninja72606", "fabix221YT", "Dark_Emerald525", "plentysun", "dev_duckyy"]} />
     <DeploymentCard showToast={showToast} title="Deployment: Give me Bobux" description="Deployment together with 101st against USMC, with around 30 attendees, on 21st April 2025." image={Wedge3} medals={[ArmedForcesExpiditionary, ArmyOverseasService, GlobalWarOnTerrorism]} campaignMedals={[JointServiceAchievement, IraqCampaign]} attendees={["Noay_HD1", "lowcaloriewaterr", "frankenpro", "crazybijij2", "OkayPy_Official", "Sally_H600", "boetson120fps", "fabix221YT", "balabol59"]} />
     <DeploymentCard showToast={showToast} title="Deployment: Operation Black Stones" description="Deployment together with 101st against RBA, with around 15 attendees, on 4th July 2025." image={Wedge4} medals={[ArmedForcesExpiditionary, GlobalWarOnTerrorism]} campaignMedals={[JointServiceAchievement, AfghanistanCampaign]} attendees={["Noay_HD1", "frankenpro", "crazybijij2", "cynx_n50", "COPMIKEPOLICE", "Eli_boi05", "SamAlfred2", "milejski124 ", "VOlD202002"]} />
     









     <br />
     <br />
     <br />
     <br />
     <i><p className='text-body-secondary' style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>Medals with a golden frame have additional requirements, besides participating in the event.</p></i>
    </>
  );
}

export default Deployments;
